import { cargoTypeUriTemplate } from '../templates/cargoTypeUriTemplate';
import { BookingModel } from './booking.model';
import { CargoTypeModel } from './cargo-type.model';
import { RateTerms } from '../enums/rate-terms.enum';
import { ClientRateModel } from './client-rate.model';
import { clientRateUriTemplate } from '../templates/clientRateUriTemplate';

export class BookingItemModel {
  //Details
  public dimensions?: string;
  public totalCubicMeters?: number;
  public totalWeight?: number;
  public totalLinearMeters?: number;
  public cargoTypeDetails?: CargoTypeModel;
  public bookingDetails?: BookingModel;
  public clientRateDetails?: ClientRateModel;

  constructor(
    public id?: any,
    public description?: string,
    public chasis?: string[],
    public maker?: string,
    public vinNumber?: string,
    public quantity?: number,
    public cargoType?: string,
    public length?: number,
    public width?: number,
    public height?: number,
    public unitWeight?: number,
    public revenue?: number,
    public clientRate?: string,
    public terms?: RateTerms | string
  ) { }

  public fromJSON(json: any): BookingItemModel {
    if (json) {
      this.id = json.id;
      this.description = json.description;
      this.quantity = json.quantity;
      this.cargoType = json.cargoType;
      this.maker = json.maker;
      this.vinNumber = json.vinNumber;
      this.chasis = json.chasis;
      this.length = Number(json.length);
      this.width = Number(json.width);
      this.height = Number(json.height);
      this.unitWeight = Number(json.unitWeight);
      this.revenue = Number(json.revenue);
      this.terms = json.terms;
      this.clientRate = json.clientRate;
      this.totalWeight = Number(json.totalWeight);
      this.totalCubicMeters = Number(json.totalCubicMeters);
      this.totalLinearMeters = Number(json.totalLinearMeters);
      this.dimensions = `${this.length?.toFixed(2) ?? 0.0}x${this.width?.toFixed(2) ?? 0.0
        }x${this.height?.toFixed(2) ?? 0.0}`;
      this.bookingDetails = undefined;

      //cargoType check
      if (typeof json.cargoType === 'object') {
        this.cargoTypeDetails = new CargoTypeModel().fromJSON(json.cargoType);
        this.cargoType = cargoTypeUriTemplate(this.cargoTypeDetails.id);
      } else {
        this.cargoTypeDetails = undefined;
        this.cargoType = json.cargoType;
      }

      //Check booking
      if (typeof json.booking === 'object') {
        this.bookingDetails = new BookingModel().fromJSON(json.booking);
      }

      //Client rate check
      if (typeof json.clientRate === 'object' && json.clientRate !== null) {
        this.clientRateDetails = new ClientRateModel().fromJSON(json.clientRate);
        this.clientRate = clientRateUriTemplate(this.clientRateDetails.id?.toString());
      } else if (json.clientRateId) {
        this.clientRateDetails = undefined;
        this.clientRate = clientRateUriTemplate(json.clientRateId?.toString());
      } else {
        this.clientRateDetails = undefined;
        this.clientRate = json.clientRate;
      }
    }
    return this;
  }

  public fromJSONList(json: any): BookingItemModel[] {
    if (json) {
      return json.map((element: any) =>
        new BookingItemModel().fromJSON(element)
      );
    }
    return [];
  }

  public toJSON() {
    return {
      id: this.id,
      description: this.description,
      quantity: this.quantity,
      cargoType: this.cargoType,
      length: this.length?.toString(),
      width: this.width?.toString(),
      height: this.height?.toString(),
      unitWeight: this.unitWeight?.toString(),
      revenue: this.revenue?.toString(),
      clientRate: this.clientRate,
      terms: this.terms,
      chasis: this.chasis,
      maker: this.maker,
      vinNumber: this.vinNumber,
      totalWeight: this.totalWeight,
      totalLinearMeters: this.totalLinearMeters,
      totalCubicMeters: this.totalCubicMeters,
    };
  }

  public getId() {
    return this.id ?? '';
  }

  public getReference() {
    return this.id ?? '';
  }
}
